import React, { Component } from 'react';
import {
    Tabs
} from './LabelStyle';

class Label extends Component {

    state = {
        activeKey: '0'
    }
    handleClick = (id) => {
        this.setState({
            activeKey: id
        })
        this.props.cb && this.props.cb(id, null, null);
        //返回顶部
        //window.scrollTo( 0, 0 );
    }
    render() {
        return (
            <Tabs>
                <div className={this.state.activeKey === '0' ? 'selected' : ''} >
                    <span>艺相约</span>
                    {
                        this.state.activeKey === '0' ? <div /> : ''
                    }
                </div>

            </Tabs>
        )
    }
}

export default Label;
